module.exports = __webpack_public_path__ + "img/portfolio-06-481x325.23cab560.jpg";